<template>
  <footer class="bg-gray-3">
    <span
      v-if="isSaving"
      class="cl-gray-50 no-select"
    >
      Salvando...
    </span>
    <span
      v-else
      class="cl-gray-50 no-select"
    >
      Salvo automaticamente às {{ savedOn | formatDateTime }}
    </span>
  </footer>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'EditionFooter',
  filters: {
    formatDateTime(date) {
      const formatter = new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });

      const formattedDate = formatter.format(date);

      return formattedDate.split(' ').reverse().join(', ');
    },
  },
  computed: {
    ...mapState({
      isSaving: 'loading',
      savedOn: 'savedOn',
    }),
  },
};
</script>

<style lang="scss" scoped>
footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  text-align: right;
  height: 24px;
  line-height: 24px;
  box-shadow: 5px 5px 10px 0px #c2c2c2;
  z-index: 6;

  span {
    font-style: italic;
    padding: 0 24px;
  }
}
</style>
